import type { Database } from '@/entities/database';
import request from '@/shared/api/request';

export const renameDatabase = (uuid: string, name: string): Promise<{ database: Database }> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { name, action: 'rename' },
  });
